import { getFunctions, httpsCallable } from "firebase/functions";
import { GrowthService } from "../GrowthService";
import { ResearchAgent } from "./ResearchAgent";
import { OutreachAgent } from "./OutreachAgent";

const fn = (name) => httpsCallable(getFunctions(), name);

export const ManagerAgent = {
  async prioritize(leads) {
    const scored = leads.map((l) => {
      let priority = 0;
      if (l.score) priority += l.score * 10;
      if (l.status === "replied") priority += 50;
      if (l.status === "researched") priority += 20;
      if (l.status === "new") priority += 5;
      if (l.status === "outreach_sent") priority += 15;
      if (l.email) priority += 10;
      if (l.instagram) priority += 5;
      return { ...l, priority };
    });
    return scored.sort((a, b) => b.priority - a.priority);
  },

  async runPipeline(lead, onStatus, signupUrl, demoBookingUrl, voiceSamples) {
    const log = (msg) => onStatus && onStatus(msg);

    log("Researching lead...");
    const research = await ResearchAgent.research(lead);
    await GrowthService.saveResearch(lead.id, research);
    log("Research complete. Generating outreach...");

    const outreach = await OutreachAgent.generate(lead, research, signupUrl, demoBookingUrl, voiceSamples);
    await GrowthService.saveOutreach(lead.id, outreach);
    log("Done.");

    return { research, outreach };
  },

  async getFollowUpQueue(leads, daysThreshold = 5) {
    const now = Date.now();
    return leads.filter((l) => {
      if (l.status !== "outreach_sent") return false;
      if (!l.lastContactedAt) return false;
      const lastTs = l.lastContactedAt?.seconds
        ? l.lastContactedAt.seconds * 1000
        : new Date(l.lastContactedAt).getTime();
      return (now - lastTs) / (1000 * 60 * 60 * 24) >= daysThreshold;
    });
  },

  async analyzeHealth(metrics) {
    const call = fn("growthAnalyzePipelineHealth");
    const result = await call({ metrics });
    return result.data.health;
  },
};
